// Set the API_URL to customize your server url
//export const API_URL = process.env.REACT_APP_API_URL || "";
//export const API_URL = "https://icebreaker-backend-2c94ae827e9e.herokuapp.com";
//export const API_URL = "http://localhost:8000";
export const API_URL = "";
export const TOKEN_KEY = "backend-jwt-token";
export const GOOGLE_API_KEY = 'AIzaSyCBPe-yrslVtqDArwkBq3Zh_XmKfRGjINw';
//42cc3301c7a93a8b766421017061c976Tz03NDY4NCxFPTE3MjYzMjEzNTMwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=